module.exports = __webpack_public_path__ + "img/promo-page-modal.90d7eacd.jpg";